/* Publish by EComposer at 2026-10-01 08:55:13*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ee6i7azx3l"]=  window.__ectimmers["ecom-ee6i7azx3l"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ee6i7azx3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ee6i7azx3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8c2102y24tf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8c2102y24tf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qax0dxqw2q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qax0dxqw2q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9bnglk34l6m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9bnglk34l6m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n27n72d6csp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n27n72d6csp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xczvz3nuva').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xczvz3nuva', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n2y18lxmae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n2y18lxmae', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-knqohqtu1v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-knqohqtu1v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-frk543m292r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-frk543m292r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0a6qul251hen').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0a6qul251hen', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s0n17b3eez').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s0n17b3eez', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mlpy95pxzsd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mlpy95pxzsd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0yxwlallwac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0yxwlallwac', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u8g65r7o7mo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u8g65r7o7mo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gwom7z70w1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gwom7z70w1g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jmzbdoin54n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jmzbdoin54n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bet75phegdt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bet75phegdt', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-h6etqslw1oc"]=  window.__ectimmers["ecom-h6etqslw1oc"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-h6etqslw1oc"]["40cd6oq46"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-h6etqslw1oc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h6etqslw1oc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mbjxcv8i3n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbjxcv8i3n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-revmufuzun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-revmufuzun', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-10haq7sua6hq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-10haq7sua6hq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yi2w6nm8y6k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yi2w6nm8y6k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3issxvirwhg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3issxvirwhg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6r3ne1glvgm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6r3ne1glvgm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-82mj5d9q1f3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-82mj5d9q1f3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aofuwwkpc74').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aofuwwkpc74', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lzpu4kzuhgg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lzpu4kzuhgg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fryohb261ik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fryohb261ik', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xhgd9nkxqq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xhgd9nkxqq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z3kjhfptd7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z3kjhfptd7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7y7cbc6lw6p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7y7cbc6lw6p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ynqwcwg9kmk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ynqwcwg9kmk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-or2ssywkht').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-or2ssywkht', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6vftp01hpm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6vftp01hpm', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-d27aak0yqpb"]=  window.__ectimmers["ecom-d27aak0yqpb"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-d27aak0yqpb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d27aak0yqpb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zseeqbs6gw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zseeqbs6gw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-07fccc2brzj7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-07fccc2brzj7', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x0ngory33i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x0ngory33i', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2tlz4aqaq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2tlz4aqaq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}